'use strict';

angular.module('AcaApp').factory('ImportMappingService',
[
  'ImportMappingResource',
  function(ImportMappingResource){
    return{
      sendMapping: function(mapName, mapping, mode){
        var rpcConfig = {method: 'receiveMapping', params: [mapName, JSON.stringify(mapping), mode]};
        return ImportMappingResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);